var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { uniqueId } from 'lodash';
import { AccordionSet, Layer, LoadingPane, Pane, Paneset, } from '@folio/stripes/components';
import { useIntl } from 'react-intl';
import { useQueryClient } from 'react-query';
import { TitleManager, useStripes } from '@folio/stripes/core';
import { t, isInactive, isInDraft, isCanned, computeErrorMessage, isEmptyList } from '../../services';
import { useListDetails, useRefresh, useDeleteList, useCSVExport, useMessages, useVisibleColumns, useRecordTypeLabel } from '../../hooks';
import { ListAppIcon, ListInformationMenu, MetaSectionAccordion, SuccessRefreshSection, ListInformationResultViewer } from './components';
import { HOME_PAGE_URL } from '../../constants';
import { ConfirmDeleteModal, CompilingLoader, ErrorComponent } from '../../components';
export var ListInformationPage = function () {
    var _a, _b, _c, _d;
    var history = useHistory();
    var intl = useIntl();
    var stripes = useStripes();
    var formatNumber = useIntl().formatNumber;
    var id = useParams().id;
    var _e = useVisibleColumns(id), handleColumnsChange = _e.handleColumnsChange, visibleColumns = _e.visibleColumns, setDefaultVisibleColumns = _e.setDefaultVisibleColumns;
    var _f = useListDetails(id, {
        onSuccess: function (newData) {
            setDefaultVisibleColumns(newData.fields);
        }
    }), listData = _f.data, isDetailsLoading = _f.isLoading, refetchDetails = _f.refetchDetails, detailsError = _f.detailsError;
    var _g = (listData !== null && listData !== void 0 ? listData : {}).name, listName = _g === void 0 ? '' : _g;
    var _h = useState(uniqueId()), refreshTrigger = _h[0], setRefreshTrigger = _h[1];
    var recordTypeLabel = useRecordTypeLabel(listData === null || listData === void 0 ? void 0 : listData.entityTypeId);
    var _j = useCSVExport({
        listId: id,
        listName: listName
    }), requestExport = _j.requestExport, isExportInProgress = _j.isExportInProgress, isCancelExportInProgress = _j.isCancelExportInProgress, cancelExport = _j.cancelExport;
    var queryClient = useQueryClient();
    var _k = useState(false), showSuccessRefreshMessage = _k[0], setShowSuccessRefreshMessage = _k[1];
    var _l = useState(false), showConfirmDeleteModal = _l[0], setShowConfirmDeleteModal = _l[1];
    var _m = useMessages(), showSuccessMessage = _m.showSuccessMessage, showErrorMessage = _m.showErrorMessage;
    var _o = useRefresh({
        listId: id,
        inProgressRefresh: listData === null || listData === void 0 ? void 0 : listData.inProgressRefresh,
        onErrorPolling: function (code) {
            showErrorMessage({
                message: t(code || 'callout.list.refresh.ErrorComponent', {
                    listName: listName
                })
            });
        },
        onSuccessPolling: function () {
            setShowSuccessRefreshMessage(true);
        },
        onError: function (error) {
            (function () { return __awaiter(void 0, void 0, void 0, function () {
                var errorMessage;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, computeErrorMessage(error, 'callout.list.refresh.ErrorComponent', {
                                listName: listName
                            })];
                        case 1:
                            errorMessage = _a.sent();
                            showErrorMessage({ message: errorMessage });
                            return [2 /*return*/];
                    }
                });
            }); })();
        },
        onCancelError: function (error) {
            (function () { return __awaiter(void 0, void 0, void 0, function () {
                var errorMessage;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, computeErrorMessage(error, 'cancel-refresh.default', {
                                listName: listName
                            })];
                        case 1:
                            errorMessage = _a.sent();
                            showErrorMessage({ message: errorMessage });
                            return [2 /*return*/];
                    }
                });
            }); })();
        },
        onCancelSuccess: function () {
            refetchDetails();
            showSuccessMessage({
                message: t('cancel-refresh.success', {
                    listName: listName
                })
            });
        }
    }), initRefresh = _o.initRefresh, isRefreshInProgress = _o.isRefreshInProgress, cancelRefresh = _o.cancelRefresh, isCancelRefreshInProgress = _o.isCancelRefreshInProgress, polledData = _o.polledData;
    var _p = useDeleteList({ id: id, onSuccess: function () {
            showSuccessMessage({
                message: t('callout.list.delete.success', {
                    listName: listName
                })
            });
            history.push(HOME_PAGE_URL);
        },
        onError: function (error) { return __awaiter(void 0, void 0, void 0, function () {
            var errorMessage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, computeErrorMessage(error, 'callout.list.delete.error', {
                            listName: listName
                        })];
                    case 1:
                        errorMessage = _a.sent();
                        showErrorMessage({ message: errorMessage });
                        return [2 /*return*/];
                }
            });
        }); } }), isDeleteInProgress = _p.isDeleteInProgress, deleteList = _p.deleteList;
    var updateListDetailsData = function () {
        queryClient.setQueryData(['listDetails', id], polledData);
    };
    var deleteListHandler = function () {
        setShowConfirmDeleteModal(false);
        deleteList();
    };
    var closeSuccessMessage = function () {
        setShowSuccessRefreshMessage(false);
    };
    var _q = useState([]), columnControls = _q[0], setColumnControls = _q[1];
    if (detailsError) {
        return React.createElement(ErrorComponent, { error: detailsError });
    }
    var refresh = function () {
        if (!(listData === null || listData === void 0 ? void 0 : listData.inProgressRefresh)) {
            initRefresh();
            closeSuccessMessage();
            if (showSuccessRefreshMessage && polledData) {
                updateListDetailsData();
            }
        }
    };
    var onVewListClickHandler = function () {
        if (polledData) {
            updateListDetailsData();
        }
        setRefreshTrigger(uniqueId());
        setShowSuccessRefreshMessage(false);
    };
    if (isDetailsLoading) {
        return React.createElement(LoadingPane, null);
    }
    var recordCount = (_b = (_a = listData === null || listData === void 0 ? void 0 : listData.successRefresh) === null || _a === void 0 ? void 0 : _a.recordsCount) !== null && _b !== void 0 ? _b : 0;
    var buttonHandlers = {};
    if (stripes.hasPerm("lists.item.refresh" /* USER_PERMS.RefreshList */)) {
        buttonHandlers['cancel-refresh'] = function () {
            cancelRefresh();
        };
        buttonHandlers.refresh = function () {
            refresh();
        };
    }
    if (stripes.hasPerm("lists.item.update" /* USER_PERMS.UpdateList */)) {
        buttonHandlers.edit = function () {
            history.push("".concat(id, "/edit"));
        };
        buttonHandlers.copy = function () {
            history.push("".concat(id, "/copy"));
        };
    }
    if (stripes.hasPerm("lists.item.delete" /* USER_PERMS.DeleteList */)) {
        buttonHandlers.delete = function () {
            setShowConfirmDeleteModal(true);
        };
    }
    if (stripes.hasPerm("lists.item.export.get" /* USER_PERMS.ExportList */)) {
        buttonHandlers.export = function () { return requestExport(); };
        buttonHandlers['cancel-export'] = function () { return cancelExport(); };
    }
    var conditions = {
        isRefreshInProgress: isRefreshInProgress,
        isCancelRefreshInProgress: isCancelRefreshInProgress,
        isExportInProgress: isExportInProgress,
        isCancelExportInProgress: isCancelExportInProgress,
        isDeleteInProgress: isDeleteInProgress,
        isListInactive: isInactive(listData),
        isListInDraft: isInDraft(listData),
        isListCanned: isCanned(listData),
        isListEmpty: isEmptyList(listData)
    };
    return (React.createElement(TitleManager, { page: intl.formatMessage({ id: 'ui-lists.title.infoList' }, { listName: listName }) },
        React.createElement(Paneset, { "data-testid": "listInformation" },
            React.createElement(Layer, { isOpen: true, contentLabel: listName },
                React.createElement(Paneset, { isRoot: true },
                    React.createElement(Pane, { dismissible: true, defaultWidth: "fill", appIcon: React.createElement(ListAppIcon, null), paneTitle: listName, paneSub: !isRefreshInProgress ?
                            t('mainPane.subTitle', { count: formatNumber(recordCount) })
                            :
                                React.createElement(CompilingLoader, null), lastMenu: React.createElement(ListInformationMenu, { stripes: stripes, visibleColumns: visibleColumns, columns: columnControls, onColumnsChange: handleColumnsChange, buttonHandlers: buttonHandlers, conditions: conditions }), onClose: function () { return history.push(HOME_PAGE_URL); }, subheader: React.createElement(SuccessRefreshSection, { shouldShow: showSuccessRefreshMessage, recordsCount: formatNumber((_d = (_c = polledData === null || polledData === void 0 ? void 0 : polledData.successRefresh) === null || _c === void 0 ? void 0 : _c.recordsCount) !== null && _d !== void 0 ? _d : 0), onViewListClick: onVewListClickHandler }) },
                        React.createElement(AccordionSet, null,
                            React.createElement(MetaSectionAccordion, { listInfo: listData, recordType: recordTypeLabel })),
                        React.createElement(AccordionSet, null,
                            React.createElement(ListInformationResultViewer, { refreshInProgress: isRefreshInProgress, listID: listData === null || listData === void 0 ? void 0 : listData.id, userFriendlyQuery: listData === null || listData === void 0 ? void 0 : listData.userFriendlyQuery, entityTypeId: listData === null || listData === void 0 ? void 0 : listData.entityTypeId, refreshTrigger: Number(refreshTrigger), setColumnControlList: setColumnControls, visibleColumns: visibleColumns }))))),
            React.createElement(ConfirmDeleteModal, { listName: listName, onCancel: function () { return setShowConfirmDeleteModal(false); }, onConfirm: function () {
                    deleteListHandler();
                }, open: showConfirmDeleteModal }))));
};
